import { FormType } from '../../../form-types';
import { ZaludEarInfectionQuestionFieldAnswers } from './questions';

const earInfection: FormType<ZaludEarInfectionQuestionFieldAnswers> = {
  name: 'Ear Infection Intake',
  questions: [
    {
      key: 'zalud_earInfection_redFlagSymptoms',
      next: {
        condition: { 'zalud_earInfection_redFlagSymptoms.none': true },
        key: 'zalud_earInfection_fever',
        els: 'zalud_earInfection_ineligible'
      }
    },
    'zalud_earInfection_fever',
    'zalud_earInfection_earsAffected',
    'zalud_earInfection_symptoms',
    'zalud_earInfection_past7Days',
    'zalud_earInfection_jawToothPain',
    'zalud_earInfection_dentalProcedures',
    'zalud_earInfection_additionalComments',
    {
      key: 'zalud_earInfection_consent',
      next: {
        condition: { 'zalud_earInfection_consent.proceed': true },
        key: 'zalud_earInfection_complete',
        els: 'zalud_earInfection_ineligible'
      }
    },
    'zalud_earInfection_complete',
    'zalud_earInfection_ineligible'
  ]
};

export default earInfection;
